import { callRpc } from "./client";

export type FavoritosPorDominio = Record<string, string[]>;

interface RespostaFavoritos {
  sucesso?: boolean;
  erro?: string;
  favoritos?: FavoritosPorDominio;
}

/** HTTP 200 também pode conter uma recusa; nunca confirmar a estrela nesse caso. */
async function confirmarResposta(promessa: Promise<RespostaFavoritos>): Promise<RespostaFavoritos> {
  const resposta = await promessa;
  if (resposta.sucesso !== true) throw new Error(resposta.erro || "Não foi possível salvar os favoritos.");
  return resposta;
}

export function sincronizarFavoritosUsuario(migracao: FavoritosPorDominio) {
  return confirmarResposta(callRpc<RespostaFavoritos>("sincronizarFavoritosUsuario", { migracao }));
}

export function salvarFavoritoUsuario(dominio: string, referenciaId: string | number, favorito: boolean) {
  return confirmarResposta(callRpc<RespostaFavoritos>("salvarFavoritoUsuario", { dominio, referenciaId, favorito }));
}

export function limparFavoritosUsuario(dominio: string) {
  return confirmarResposta(callRpc<RespostaFavoritos>("limparFavoritosUsuario", { dominio }));
}
